import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { DemandeEditionTableauDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";
import { LigneJournalDto } from "../../../dto/GenApi.iNotPaie.Dto/LigneJournalDto";
import { VueBase } from "../../Controls/VueBase";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

interface cumulLigneJournal {
	Compte?: string;
	Debit: number;
	Credit: number;
	SoldeDebit: number;
	SoldeCredit: number;
}

@Component
export default class ModalJournalTableau extends VueBase {
	public ligneJournal: LigneJournalDto[] = [];
	public tableau?: DemandeEditionTableauDto = undefined;
	public cumulLigneJournal: cumulLigneJournal[] = [];
	public titre = "";
	public exportExcel = false;
	public dataReady = false;

	public Init(tableau: DemandeEditionTableauDto): void {
    	this.tableau = tableau;
    	this.exportExcel = tableau.exportExcel ?? false;
    	this.titre = tableau.libelleEdition as string;
    	this.cumulLigneJournal = [];
    	this.ligneJournal = [];

    	ServicesFactoryInstance.EditionsService.getJournal(tableau, (data) => {
    		this.dataReady = true;
    		this.ligneJournal = data;
    		this.cumulLigneJournal = [];
    		const ligneRacine4 = { Compte: "4******", Credit: 0, Debit: 0, SoldeCredit: 0, SoldeDebit: 0 };
    		this.cumulLigneJournal.push(ligneRacine4);

    		for (let i = 0; i < this.ligneJournal.length; i++) {
    			const ligne = this.ligneJournal[i];
    			if (ligne.CompteCredit != "" && ligne.CompteDebit != "4******") {
					let ligneCumulExistCred = this.cumulLigneJournal.filter(c => c.Compte == ligne.CompteCredit)[0];
    				if (ligneCumulExistCred == undefined) {
    					ligneCumulExistCred = {
    						Compte: ligne.CompteCredit,
    						Credit: ligne.Montant,
    						Debit: 0,
    						SoldeCredit: ligne.Montant,
    						SoldeDebit: 0
    					};
    					this.cumulLigneJournal.push(ligneCumulExistCred);
    				} else {
    					ligneCumulExistCred.Credit += ligne.Montant;
						const solde = ligneCumulExistCred.Credit - ligneCumulExistCred.Debit;
    					ligneCumulExistCred.SoldeCredit = solde > 0 ? solde : 0;
    					ligneCumulExistCred.SoldeDebit = solde < 0 ? -solde : 0;
    				}
    				if (ligne.ChargePatronal) {
						ligneRacine4.Credit += ligne.Montant;
					}
    			}
    			if (ligne.CompteDebit != "" && ligne.CompteDebit != "4******") {
					let ligneCumulExistDeb = this.cumulLigneJournal.filter(c => c.Compte == ligne.CompteDebit)[0];
    				if (ligneCumulExistDeb == undefined) {
    					ligneCumulExistDeb = {
    						Compte: ligne.CompteDebit,
    						Debit: ligne.Montant,
    						Credit: 0,
    						SoldeDebit: ligne.Montant,
    						SoldeCredit: 0
    					};
    					this.cumulLigneJournal.push(ligneCumulExistDeb);
    				} else {
    					ligneCumulExistDeb.Debit += ligne.Montant;
						const solde = ligneCumulExistDeb.Credit - ligneCumulExistDeb.Debit;
    					ligneCumulExistDeb.SoldeCredit = solde > 0 ? solde : 0;
    					ligneCumulExistDeb.SoldeDebit = solde < 0 ? -solde : 0;
    				}

    				if (ligne.ChargePatronal) {
						ligneRacine4.Debit += ligne.Montant;
					}
    			}
    		}

			const solde = ligneRacine4.Credit - ligneRacine4.Debit;
    		ligneRacine4.SoldeCredit = solde > 0 ? solde : 0;
    		ligneRacine4.SoldeDebit = solde < 0 ? -solde : 0;

    		this.cumulLigneJournal = this.cumulLigneJournal.sort((a, b) => {
    			if (a.Compte == "4******") {
					return -1;
				}
    			if (a.Compte == undefined) {
					return -1;
				}
    			if (b.Compte == undefined) {
					return 1;
				}

    			return a.Compte > b.Compte ? 1 : -1;
    		});
    	});
	}

	public annuler(): void {
    	$("#modalJournalTableau").modal("hide");
	}

	public LancerEdition(): void {
    	$("#modalJournalTableau").modal("hide");
    	if (this.tableau == undefined) {
			return;
		}
    	NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

    	this.tableau.exportExcel = this.exportExcel;
    	ServicesFactoryInstance.EditionsService.getEditionTableau(this.tableau, (r: Blob) => {
			if (this.tableau == undefined) {
				return;
			}

    		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    			window.navigator.msSaveOrOpenBlob(r, this.tableau.libelleEdition);
    		} else {
				const link = document.createElement("a");
    			document.body.appendChild(link);

    			link.href = window.URL.createObjectURL(r);
    			link.download = this.tableau.libelleEdition + (this.exportExcel ? ".xlsx" : ".pdf");
    			link.click();

    			NotificationServiceInstance.SendSuccess("L'édition de la liste '" + this.tableau.libelleEdition + "' s'est correctement déroulée !");
    		}
    	});
	}

	public GetUrlProtocol(): void {
    	$("#modalJournalTableau").modal("hide");
    	if (this.tableau == undefined) {
			return;
		}

    	NotificationServiceInstance.SendSuccess("La récupération du lien vers la comptabilité a été prise en compte. Le document sera bientôt disponible");
    	ServicesFactoryInstance.EditionsService.getUrlOdPaie(this.tableau, (r: Blob) => {
			if (this.tableau == undefined) {
				return;
			}

    		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    			window.navigator.msSaveOrOpenBlob(r, this.tableau.libelleEdition);
			} else {
				const link = document.createElement("a");
    			document.body.appendChild(link);

    			link.href = window.URL.createObjectURL(r);
    			link.download = this.tableau.libelleEdition + ".url";
    			link.click();

    			NotificationServiceInstance.SendSuccess("La récupération du lien vers la comptabilité s'est correctement déroulée !");
    		}
    	});
	}
}




// WEBPACK FOOTER //
// ./src/components/tableaux/modalJournalTableau/modalJournalTableau.ts